import { useParams } from '@rocketlane/rocket-router';
import { useSalesforceConfigByIdQuery } from 'queries/salesforce';
import {
  SalesforceTabsType,
  SalesforceTabs,
} from 'components/molecules/integrations/salesforce/tabs';
import { AutomationList } from 'components/organisms/integrations/salesforce/automation-list';
import { SalesforceLayout } from './salesforce-layout';

function AutomationsListPage() {
  const { integrationId } = useParams<{ integrationId: string }>();
  const { data } = useSalesforceConfigByIdQuery(Number(integrationId), {
    enabled: integrationId !== 'new',
  });

  return (
    <SalesforceLayout
      tabs={
        <SalesforceTabs
          activeKey={SalesforceTabsType.Automations}
          integrationId={integrationId}
          integrationStatus={data?.integrationStatus}
        />
      }
      content={<AutomationList />}
      actions={{}}
    />
  );
}

export { AutomationsListPage };
